import mockUseKeycloak from './mockUseKeycloak'
import { reactKeycloakWebContext } from './context'
import { useContext } from 'react'

export const useKeycloak = () => {
  const ctx = useContext(reactKeycloakWebContext)

  if (!ctx) {
    throw new Error(
      'useKeycloak hook must be used inside ReactKeycloakProvider context'
    )
  }

  const {
    authClient,
    initialized
  } = ctx

  if (!authClient) {
    // Allow Jest and Cypress to proceed
    if (import.meta.env.VITE_IS_AUTH_DISABLED === 'true') return mockUseKeycloak

    throw new Error('authClient has not been assigned to ReactKeycloakProvider')
  }

  return {
    initialized,
    keycloak: authClient
  }
}
